export const DEFAULT_COVERED_MEMBER_LIMIT = 25;

export const coveredMemberPkey = (customer) => {
	const rawPkey = customer && typeof customer === "object"
		? (typeof customer.pkey !== "undefined"
			? customer.pkey
			: (typeof customer.value !== "undefined"
				? customer.value
				: (customer.original && customer.original.pkey)))
		: customer;

	if (typeof rawPkey === "number") {
		return Number.isSafeInteger(rawPkey) && rawPkey > 0 ? rawPkey : null;
	}
	if (typeof rawPkey !== "string" || !/^\d+$/.test(rawPkey)) {
		return null;
	}

	const pkey = Number(rawPkey);
	return Number.isSafeInteger(pkey) && pkey > 0 ? pkey : null;
};

export const normalizeCoveredMemberPkeys = (customers, payingCustomer = null) => {
	const payingCustomerPkey = coveredMemberPkey(payingCustomer);

	return (Array.isArray(customers) ? customers : [])
		.map(coveredMemberPkey)
		.filter((customer) => customer !== null && customer !== payingCustomerPkey)
		.filter((customer, index, collection) => collection.indexOf(customer) === index);
};

export const membershipCardMembers = (payingCustomer, coveredMembers) => {
	const payingCustomerPkey = coveredMemberPkey(payingCustomer);
	const members = [];

	if (payingCustomerPkey !== null) {
		members.push({
			...(payingCustomer && typeof payingCustomer === "object" ? payingCustomer : {}),
			pkey: payingCustomerPkey,
			membership_card_role: "payer",
		});
	}

	(Array.isArray(coveredMembers) ? coveredMembers : []).forEach((coveredMember) => {
		const coveredCustomerPkey = coveredMemberPkey(coveredMember);
		if (
			coveredCustomerPkey === null
			|| coveredCustomerPkey === payingCustomerPkey
			|| members.some((member) => member.pkey === coveredCustomerPkey)
		) {
			return;
		}

		members.push({
			...(coveredMember && typeof coveredMember === "object" ? coveredMember : {}),
			pkey: coveredCustomerPkey,
			membership_card_role: "covered",
		});
	});

	return members;
};

export const generatedCustomerBarcode = (barcodes) => (
	(Array.isArray(barcodes) ? barcodes : []).find((barcode) => (
		barcode
		&& String(barcode.source || "").trim().toLowerCase() === "generated"
		&& String(barcode.barcode || "").trim() !== ""
	)) || null
);

export const coveredMemberOptionIsDisabled = (
	selectedCustomers,
	candidate,
	limit = DEFAULT_COVERED_MEMBER_LIMIT,
) => {
	const selectedPkeys = normalizeCoveredMemberPkeys(selectedCustomers);
	const candidatePkey = coveredMemberPkey(candidate);
	const normalizedLimit = coveredMemberPkey(limit) || DEFAULT_COVERED_MEMBER_LIMIT;

	return selectedPkeys.length >= normalizedLimit
		&& (candidatePkey === null || selectedPkeys.indexOf(candidatePkey) === -1);
};

export const coveredMemberStorageReady = (value) => (
	[true, 1, "1", "true"].indexOf(value) !== -1
);

export const membershipRole = (membership) => (
	String(membership && membership.membership_role || "payer").trim().toLowerCase()
);

export const membershipDateSummary = (membership, formatDate = (date) => date) => {
	if (membership && membership.cancelled_at) {
		return `Cancelled ${formatDate(membership.cancelled_at)}`;
	}
	if (membership && membership.end_date) {
		return `Ends ${formatDate(membership.end_date)}`;
	}
	if (membership && membership.next_bill_date) {
		return `Renews ${formatDate(membership.next_bill_date)}`;
	}

	return "No expiration";
};

export const membershipCountsTowardCustomerLimit = (membership, comparisonDate = "") => {
	const status = String(membership && membership.status || "").trim().toLowerCase();
	const endDate = String(membership && membership.end_date || "").slice(0, 10);

	return !!membership
		&& !membership.cancelled_at
		&& ["paused", "canceled", "cancelled", "deleted"].indexOf(status) === -1
		&& (!comparisonDate || !endDate || endDate >= comparisonDate);
};

export const membershipMatchesPayingCustomer = (membership, customer) => {
	const customerPkey = coveredMemberPkey(customer);
	return customerPkey !== null
		&& coveredMemberPkey(membership && membership.customer) === customerPkey;
};

export const membershipIncludesCustomer = (membership, customer) => {
	const customerPkey = coveredMemberPkey(customer);
	return customerPkey !== null
		&& (
			membershipMatchesPayingCustomer(membership, customerPkey)
			|| coveredMemberPkey(membership && membership.recognized_customer) === customerPkey
		);
};
